import { useState } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { content } from "../../data/content";
import { Reveal } from "./Reveal";

const FRONTS = ["bg-rose text-white", "bg-grape text-white", "bg-sky text-white"];

function FlipCard({ item, index }) {
  const [flipped, setFlipped] = useState(false);
  return (
    <div
      className="relative h-52 md:h-56"
      style={{ perspective: "1200px" }}
      data-testid={`flip-card-${index}`}
    >
      <motion.button
        onClick={() => setFlipped((f) => !f)}
        className="relative w-full h-full outline-none"
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.6, ease: [0.34, 1.3, 0.64, 1] }}
        style={{ transformStyle: "preserve-3d" }}
        whileHover={{ scale: 1.03 }}
        aria-label={`Voltear tarjeta ${index + 1}`}
      >
        {/* front */}
        <span
          className={`${FRONTS[index % FRONTS.length]} absolute inset-0 rounded-2xl border-[3px] border-ink shadow-brutal-lg flex flex-col items-center justify-center`}
          style={{ backfaceVisibility: "hidden" }}
        >
          <span className="font-accent text-6xl md:text-7xl leading-none">
            {item.n}
          </span>
          <span className="mt-2 flex items-center gap-1 font-body font-extrabold text-xs uppercase tracking-widest opacity-80">
            <Sparkles className="w-4 h-4" /> voltear
          </span>
        </span>
        {/* back */}
        <span
          className="bg-white absolute inset-0 rounded-2xl border-[3px] border-ink shadow-brutal-lg flex items-center justify-center p-5 text-center"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
        >
          <span className="font-body font-bold text-base md:text-xl text-ink leading-snug">
            {item.reason}
          </span>
        </span>
      </motion.button>
    </div>
  );
}

export function FlipReasons() {
  return (
    <section
      data-testid="reasons-section"
      className="relative w-full bg-lilac px-5 md:px-10 py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto">
        <Reveal className="text-center mb-14 md:mb-20">
          <p className="font-accent text-3xl md:text-5xl text-rose -rotate-2 mb-1">
            {content.flipReasons.kicker}
          </p>
          <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-ink">
            {content.flipReasons.title}
          </h2>
          <p className="font-body font-semibold text-base md:text-xl text-ink/70 mt-3">
            {content.flipReasons.subtitle}
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-8">
          {content.flipReasons.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <FlipCard item={item} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
